import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { buildSenders, senderTitle, valueOf, whatsappWindowHours } from "../../SelectSender/senders";
import "./SwitchBanner.less";

// Above the composer after the customer switched channel or number (until we reply): says where replies go now
// (the composer followed the customer) and offers the previous way back.
const SwitchBanner = ({intl, change, messages, phoneNumbers, onChoose}) => {
    const t = (id, defaultMessage, values) => intl.formatMessage({id, defaultMessage}, values);
    if (!change) return null;
    const senders = buildSenders(phoneNumbers);
    const able = (number, channel) => senders.some(sender => sender.number === String(number) && sender[channel]);
    const number = senderTitle(change.number, phoneNumbers);
    const before = senderTitle(change.before.number, phoneNumbers, change.before.customName);

    let text;
    let back = null;
    if (change.type === "channel") {
        const other = change.channel === "whatsapp" ? "sms" : "whatsapp";
        const backNumber = able(change.before.number, other) ? change.before.number : able(change.number, other) ? change.number : null;
        const hours = change.channel === "whatsapp" ? whatsappWindowHours(messages) : null;
        text = (
            <>
                <FormattedMessage
                    id="chats.switchRepliesNow"
                    defaultMessage="Replies now go by {channel} from {number}"
                    values={{channel: <b>{change.channel === "whatsapp" ? "WhatsApp" : "SMS"}</b>, number}}
                />
                <span className="switch-banner__muted">
                    {" · "}{t("chats.switchBefore", "before: {channel} from {number}", {channel: change.before.channel === "whatsapp" ? "WhatsApp" : "SMS", number: before})}
                    {hours ? <> · {t("chats.switchWindow", "{hours} h left in the reply window", {hours})}</> : null}
                </span>
            </>
        );
        if (backNumber) back = {
            label: other === "sms" ? t("chats.switchBackSms", "Reply by SMS instead") : t("chats.switchBackWhatsapp", "Reply on WhatsApp instead"),
            value: valueOf(backNumber, other)
        };
    } else {
        text = (
            <>
                <b>{t("chats.switchSenderChangedOn", "Sender changed to {number} on {channel}", {number, channel: change.channel === "whatsapp" ? "WhatsApp" : "SMS"})}</b>
                <span className="switch-banner__muted"> · {t("chats.switchNumberUsedBefore", "the number the customer used (before: {before})", {before})}</span>
            </>
        );
        if (able(change.before.number, change.before.channel)) back = {
            label: t("chats.switchKeep", "Keep {before}", {before}),
            value: valueOf(change.before.number, change.before.channel)
        };
    }

    return (
        <div className={`switch-banner is-${change.type === "channel" ? change.channel : "number"}`} role="status">
            <span className="switch-banner__dot" aria-hidden="true"/>
            <span className="switch-banner__text">{text}</span>
            {back ? <button type="button" className="switch-banner__back" onClick={() => onChoose(back.value)}>{back.label}</button> : null}
        </div>
    );
};

export default injectIntl(SwitchBanner);
